import React from 'react';
import { Settings } from 'lucide-react';

const PMODashboard = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
          <Settings className="w-7 h-7 text-indigo-600 dark:text-indigo-400" />
          PMO Dashboard
        </h1>
        <p className="text-gray-600 dark:text-gray-400">Project Management Office overview</p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <p className="text-gray-600 dark:text-gray-400">
          PMO Dashboard coming soon...
        </p>
      </div>
    </div>
  );
};

export default PMODashboard;
